export const MENSUAL_ID = 1
export const CTS_ID = 2
export const GRATIFICACION_ID = 3

export const CTS_MONTHS = [5, 11]           // Mayo, Noviembre
export const GRATIFICACION_MONTHS = [7, 12] // Julio, Diciembre

// Meses donde Mensual está habilitado (todos los que no son CTS ni Gratificación)
export const MENSUAL_MONTHS = [1, 2, 3, 4, 6, 8, 9, 10]

/**
 * Retorna el ID del tipo de solicitud requerido para un mes dado.
 */
export const getRequiredEvidenceType = (month) => {
  if (CTS_MONTHS.includes(month)) return CTS_ID
  if (GRATIFICACION_MONTHS.includes(month)) return GRATIFICACION_ID
  return MENSUAL_ID
}

/**
 * Verifica si un tipo de solicitud está permitido para un mes dado.
 */
export const isEvidenceTypeAllowed = (typeId, month) => {
  return getRequiredEvidenceType(month) === typeId
}
